<template>
    <section id="order-data">
        <div class="row">
            <div class="col-sm-6">
                <h3>{{ $t('Invoice data') }}</h3>
                <p>
                    <span class="bold">{{ $t('First name') }}, {{ $t('Last name') }}:</span>
                    {{ cartData.customer.name }} {{ cartData.customer.surname }}
                </p>
                <p>
                    <span class="bold">{{ $t('Address') }}:</span>
                    {{ cartData.customer.address }} {{ cartData.customer.number }}
                </p>
                <p>
                    <span class="bold">{{ $t('City') }}, {{ $t('Zip') }}:</span>
                    {{ cartData.customer.city }} {{ cartData.customer.zip }}
                </p>
                <br>
                <p>
                    <span class="bold">{{ $t('Phone number') }}:</span>
                    {{ cartData.customer.phone }}
                </p>
                <p>
                    <span class="bold">{{ $t('Email') }}:</span>
                    {{ cartData.customer.email }}
                </p>
            </div>
            <div class="col-sm-6">
                <h3>{{ $t('Shipping and payment') }}</h3>
                <p>
                    <span class="bold">{{ $t('Shipping') }}:</span>
                    {{ shippingText }}
                </p>
                <p>
                    <span class="bold">{{ $t('Payment') }}:</span>
                    {{ cartData.payment.name }}
                </p>
            </div>
            <div class="col-12">
                <br>
                <p>
                    <span class="bold">{{ $t('Notes') }}:</span>
                    {{ cartData.customer.notes }}
                </p>
            </div>
        </div>
    </section>
</template>
<script>
import {mapGetters} from "vuex";
import {packetaId} from "../../../../config";

export default {
    computed: {
        ...mapGetters({
            cartData: 'cart/getCartData',
            packeta: 'packeta/getData',         // [PACKAGE] - packeta
        }),
        shippingText() {
            // is packata
            return this.packetaId.includes(this.cartData.shipping.id)
                ? `${this.cartData.shipping.name} (${this.packeta.place})`
                : this.cartData.shipping.name
        }
    },
    setup(props) {
        return {
            packetaId,
        }
    }
}
</script>
